// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"381":"613d0dba","482":"d3c50387","923":"fbed3cfd","966":"b0c2fc73"}[chunkId] + ".chunk.js";
};